"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_native_exports = {};
__export(index_native_exports, {
  LightSensor: () => LightSensor
});
module.exports = __toCommonJS(index_native_exports);
var import_react_native_nitro_modules = require("react-native-nitro-modules");
var import_validate = require("./validate");
var hybrid;
function native() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = import_react_native_nitro_modules.NitroModules.createHybridObject("OneLightSensor");
  return hybrid;
}
function isAvailable() {
  return native().isAvailable();
}
function setUpdateInterval(intervalMs) {
  (0, import_validate.assertUpdateInterval)(intervalMs);
  native().setUpdateInterval(intervalMs);
}
function addListener(listener) {
  (0, import_validate.assertLightSensorListener)(listener);
  var remove = native().addListener(listener);
  return {
    remove: function remove1() {
      return remove();
    }
  };
}
var LightSensor = Object.freeze({
  isAvailable,
  setUpdateInterval,
  addListener
});
//# sourceMappingURL=index.native.js.map
